import { render, staticRenderFns } from "./PartslisteditPage.vue?vue&type=template&id=52cfd149"
import script from "./PartslisteditPage.vue?vue&type=script&lang=js"
export * from "./PartslisteditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports